import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/reports`;
const bomAgingUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}/bomAgingView/aging`;

export const reportService = {
  getAvailableStocks,
  getAvailableStocksByView,
  getAvailableStockTotals,
  exportExcel,
  getBinWiseBalance,
  getSupplierWiseBalance,
  getStockInOutSummary,
  exportSupplierWisePdf,
  exportSupplierWiseSummaryPdf,
  exportBinWisePdf,
  exportBinWiseSummaryPdf,
  exportStockInOutSummaryExcel,
  exportBarcodeExcel,
  getAgingData,
  getAgingDataByBomId,
  getAgingDataSearch,
  getMudForms,
  getMudFormSearch,
  getAvailableLiability
};

function getAvailableStocks(params) {
  return fetchWrapper.get(`${baseUrl}/availableStocks${params}`);
}

function getAvailableStocksByView(params) {
  return fetchWrapper.get(`${baseUrl}/availableStocksView${params}`);
}

function getAvailableStockTotals(params) {
  return fetchWrapper.get(`${baseUrl}/availableStockTotals${params}`);
}

function exportExcel(params) {
  return fetchWrapper.get(`${baseUrl}/availableStocks/export-excel${params}`, {
    responseType: 'blob',
  });
}

function exportBarcodeExcel(params) {
  return fetchWrapper.get(
    `${baseUrl}/availableStocks/export-barcode-excel${params}`,
    {
      responseType: "blob",
    }
  );
}

function getBinWiseBalance(params) {
  return fetchWrapper.get(`${baseUrl}/bin${params}`);
}

function getSupplierWiseBalance(params) {
  return fetchWrapper.get(`${baseUrl}/supplier${params}`);
}

function getStockInOutSummary(params) {
  return fetchWrapper.get(`${baseUrl}/stock-inout-summary${params}`);
}

function exportSupplierWisePdf(params) {
  return fetchWrapper.get(`${baseUrl}/supplier/pdf${params}`, {
    responseType: "blob",
  });
}

function exportSupplierWiseSummaryPdf(params) {
  return fetchWrapper.get(`${baseUrl}/supplier/pdf/summary${params}`, {
    responseType: "blob",
  });
}

function exportBinWisePdf(params) {
  return fetchWrapper.get(`${baseUrl}/bin/pdf${params}`, {
    responseType: "blob",
  });
}

function exportBinWiseSummaryPdf(params) {
  return fetchWrapper.get(`${baseUrl}/bin/pdf/summary${params}`, {
    responseType: "blob",
  });
}

function exportStockInOutSummaryExcel(params) {
  return fetchWrapper.get(`${baseUrl}/stock-inout-summary/excel${params}`, {
    responseType: "blob",
  });
}

function getAgingData() {
  return fetchWrapper.get(`${bomAgingUrl}`);
}

function getAgingDataByBomId(id) {
  return fetchWrapper.get(`${bomAgingUrl}?productId=${id}`);
}

function getAgingDataSearch(params) {
  return fetchWrapper.get(`${baseUrl}/bomAgingView/aging${params}`);
}

function getMudForms() {
  return fetchWrapper.get(`${baseUrl}/mudDocument`);
}

function getMudFormSearch(params) {
  return fetchWrapper.get(`${baseUrl}/mudDocument${params}`);
}

function getAvailableLiability() {
  return fetchWrapper.get(`${baseUrl}/rawMaterialViseVatDutyView`);
}
